<template>
  <div class="b-menu-item-bubble-actions">

    <!--<div class="b-menu-item-bubble-actions__delete" @click="$emit('click:delete')" v-if="show">-->
      <!--<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 459 459">-->
        <!--<path fill="currentColor" d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5 H51v51h357V25.5z"/>-->
      <!--</svg>-->
    <!--</div>-->

    <div class="b-menu-item-bubble-actions__edit" @click="$emit('click:edit')" v-if="show && !editMode" title="Bearbeiten">
      <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"
           xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Icon-/-News-erstellen" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path
            d="M0,23.6290672 L0,29.9349241 L6.30585683,29.9349241 L24.5596529,11.5151844 L18.2537961,5.20932755 L0,23.6290672 Z M29.3720174,6.70281996 C30.0357918,6.03904555 30.0357918,5.04338395 29.3720174,4.37960954 L25.5553145,0.562841649 C24.8915401,-0.100932755 23.8958785,-0.100932755 23.2321041,0.562841649 L20.2451193,3.54982646 L26.5509761,9.8556833 L29.3720174,6.70281996 Z"
            id="edit" fill="currentColor" fill-rule="nonzero"></path>
        </g>
      </svg>
    </div>

    <div class="b-menu-item-bubble-actions__close" @click="$emit('click:close-edit')" v-if="editMode" title="Abbrechen">
      <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
          <path d="M15,15 L29.4230769,0.576923077 L15,15 L0.576923077,0.576923077 L15,15 Z M15,15 L29.4230769,29.4230769 L15,15 L0.576923077,29.4230769 L15,15 Z"
                id="close" stroke="currentColor" stroke-width="4" fill-rule="nonzero" fill="currentColor"></path>
      </svg>
    </div>

    <div class="b-menu-item-bubble-actions__save" @click="$emit('click:save')" v-if="editMode" title="Bestätigen">
      <svg viewBox="0 0 15 13" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Symbol" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g transform="translate(-8.000000, -9.000000)" fill="currentColor" fill-rule="nonzero">
                  <polygon id="check" points="13 18.5 9.23432602 15.2763767 8 16.8975811 13.1371473 21.4832733 23 10.6212043 21.765674 9"></polygon>
              </g>
          </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'b-menu-item-bubble-actions',
  props: ['editMode', 'show']
}
</script>

<style lang="scss" scoped>
.b-menu-item-bubble-actions {
  > div {
    position: absolute;
    cursor: pointer;
    width: 15px;
    height: 15px;
  }
}

.b-menu-item-bubble-actions {
  &__delete {
    top: 0;
    right: 20px;
    color: red;
  }

  &__edit {
    top: 20px;
    right: 0;
    color: blue;
  }

  &__save {
    bottom: 25px;
    right: 20px;
    color: green;
  }

  &__close {
    bottom: 45px;
    right: 0;
    color: red;

    svg {
      height: 13px;
    }
  }
}
</style>
